const IconUserGroup = ({ width = 24, height = 25, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7363 11.7227C17.8373 11.568 18.685 10.6241 18.6873 9.48048C18.6873 8.35344 17.8657 7.41898 16.7884 7.24219"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7363 11.7227C17.8373 11.568 18.685 10.6241 18.6873 9.48048C18.6873 8.35344 17.8657 7.41898 16.7884 7.24219"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7363 11.7227C17.8373 11.568 18.685 10.6241 18.6873 9.48048C18.6873 8.35344 17.8657 7.41898 16.7884 7.24219"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7363 11.7227C17.8373 11.568 18.685 10.6241 18.6873 9.48048C18.6873 8.35344 17.8657 7.41898 16.7884 7.24219"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7363 11.7227C17.8373 11.568 18.685 10.6241 18.6873 9.48048C18.6873 8.35344 17.8657 7.41898 16.7884 7.24219"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1895 14.3691C19.2557 14.5286 20 14.9019 20 15.6714C20 16.201 19.6496 16.5451 19.0829 16.7613"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1895 14.3691C19.2557 14.5286 20 14.9019 20 15.6714C20 16.201 19.6496 16.5451 19.0829 16.7613"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1895 14.3691C19.2557 14.5286 20 14.9019 20 15.6714C20 16.201 19.6496 16.5451 19.0829 16.7613"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1895 14.3691C19.2557 14.5286 20 14.9019 20 15.6714C20 16.201 19.6496 16.5451 19.0829 16.7613"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1895 14.3691C19.2557 14.5286 20 14.9019 20 15.6714C20 16.201 19.6496 16.5451 19.0829 16.7613"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.6953C9.46335 14.6953 7.29688 15.0797 7.29688 16.6148C7.29688 18.149 9.44993 18.5444 12 18.5444C14.5366 18.5444 16.7023 18.164 16.7023 16.6282C16.7023 15.0923 14.55 14.6953 12 14.6953Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.6953C9.46335 14.6953 7.29688 15.0797 7.29688 16.6148C7.29688 18.149 9.44993 18.5444 12 18.5444C14.5366 18.5444 16.7023 18.164 16.7023 16.6282C16.7023 15.0923 14.55 14.6953 12 14.6953Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.6953C9.46335 14.6953 7.29688 15.0797 7.29688 16.6148C7.29688 18.149 9.44993 18.5444 12 18.5444C14.5366 18.5444 16.7023 18.164 16.7023 16.6282C16.7023 15.0923 14.55 14.6953 12 14.6953Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.6953C9.46335 14.6953 7.29688 15.0797 7.29688 16.6148C7.29688 18.149 9.44993 18.5444 12 18.5444C14.5366 18.5444 16.7023 18.164 16.7023 16.6282C16.7023 15.0923 14.55 14.6953 12 14.6953Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.6953C9.46335 14.6953 7.29688 15.0797 7.29688 16.6148C7.29688 18.149 9.44993 18.5444 12 18.5444C14.5366 18.5444 16.7023 18.164 16.7023 16.6282C16.7023 15.0923 14.55 14.6953 12 14.6953Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 12.5048C13.665 12.5048 15.0146 11.156 15.0146 9.49068C15.0146 7.82617 13.665 6.47656 12.0005 6.47656C10.336 6.47656 8.98635 7.82617 8.98635 9.49068C8.98006 11.1497 10.3194 12.4993 11.9784 12.5048H12.0005Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 12.5048C13.665 12.5048 15.0146 11.156 15.0146 9.49068C15.0146 7.82617 13.665 6.47656 12.0005 6.47656C10.336 6.47656 8.98635 7.82617 8.98635 9.49068C8.98006 11.1497 10.3194 12.4993 11.9784 12.5048H12.0005Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 12.5048C13.665 12.5048 15.0146 11.156 15.0146 9.49068C15.0146 7.82617 13.665 6.47656 12.0005 6.47656C10.336 6.47656 8.98635 7.82617 8.98635 9.49068C8.98006 11.1497 10.3194 12.4993 11.9784 12.5048H12.0005Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 12.5048C13.665 12.5048 15.0146 11.156 15.0146 9.49068C15.0146 7.82617 13.665 6.47656 12.0005 6.47656C10.336 6.47656 8.98635 7.82617 8.98635 9.49068C8.98006 11.1497 10.3194 12.4993 11.9784 12.5048H12.0005Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 12.5048C13.665 12.5048 15.0146 11.156 15.0146 9.49068C15.0146 7.82617 13.665 6.47656 12.0005 6.47656C10.336 6.47656 8.98635 7.82617 8.98635 9.49068C8.98006 11.1497 10.3194 12.4993 11.9784 12.5048H12.0005Z"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.26253 11.7227C6.16075 11.568 5.31389 10.6241 5.31152 9.48048C5.31152 8.35344 6.13312 7.41898 7.21044 7.24219"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.26253 11.7227C6.16075 11.568 5.31389 10.6241 5.31152 9.48048C5.31152 8.35344 6.13312 7.41898 7.21044 7.24219"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.26253 11.7227C6.16075 11.568 5.31389 10.6241 5.31152 9.48048C5.31152 8.35344 6.13312 7.41898 7.21044 7.24219"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.26253 11.7227C6.16075 11.568 5.31389 10.6241 5.31152 9.48048C5.31152 8.35344 6.13312 7.41898 7.21044 7.24219"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.26253 11.7227C6.16075 11.568 5.31389 10.6241 5.31152 9.48048C5.31152 8.35344 6.13312 7.41898 7.21044 7.24219"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.81052 14.3691C4.74426 14.5286 4 14.9019 4 15.6714C4 16.201 4.35042 16.5451 4.9171 16.7613"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.81052 14.3691C4.74426 14.5286 4 14.9019 4 15.6714C4 16.201 4.35042 16.5451 4.9171 16.7613"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.81052 14.3691C4.74426 14.5286 4 14.9019 4 15.6714C4 16.201 4.35042 16.5451 4.9171 16.7613"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.81052 14.3691C4.74426 14.5286 4 14.9019 4 15.6714C4 16.201 4.35042 16.5451 4.9171 16.7613"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.81052 14.3691C4.74426 14.5286 4 14.9019 4 15.6714C4 16.201 4.35042 16.5451 4.9171 16.7613"
        stroke={fill}
        strokeOpacity="0.2"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconUserGroup;
